module.exports = __webpack_public_path__ + "static/media/23_plantilla_combo_rectangular_marco_comida_39.75d1b239.png";